import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import Image from "../../elements/image";
import PhotoWallImage from "./PhotoWallImage";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { mobileIs, loadScrollMagic } from "../../utils/siteUtils";
import gsap from 'gsap';

import "./style.scss";
import { linear } from "@popmotion/easing";
const PhotoWall = props => {
  const  { list, image, titleImage, titleImageMobile, theme } = props.fields;
  const rootEl = useRef();
  const listEl = useRef();
  const mainEl = useRef();
  const maxImageEl = useRef();
  const titleImageEl = useRef();
  const [ photoWall , setPhotoWall ] = useState(null);
  const isMobile = mobileIs();
  let ScrollMagic, controller, scene, tl, tl2;
  useEffect(() => {
    if(!isMobile){
      init();
      window.addEventListener('resize', init)
    }else{
      initMobile();
    }
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      if(!isMobile){
        window.removeEventListener('resize', init)
      }
      scene && scene.destroy(true);
      scene = null;
      controller.destroy(true);
      controller = null;
    }
  }, []);
  const init = () => {
    scene && scene.destroy(true);
    scene = null;
    controller && controller.destroy(true);
    controller = null;
    tl = null;
    tl2 = null;
    let height = 0
    if(list.length>8){
      height = window.innerWidth * 1.1755;
    }else if(list.length>6){
      height = window.innerWidth * 0.8515624999;
    }else if(list.length>2){
      height = window.innerWidth * 0.7994791666;
    }else{
      height = window.innerWidth * 0.2734375;
    }
    setPhotoWall({
      height: height,
      background: theme?.fields?.key?.value
    })

    ScrollMagic = loadScrollMagic()
    tl = gsap.timeline();
    tl2 = gsap.timeline({paused:true});
    if(isMobile){
      tl2.to([maxImageEl.current],0.1,{
        top: '3.25520835vw',
        width: '41.1458333vw',
        height: '20.8333333vw',
        opacity: '0.3',
        translateY: 0
      },'first')
      .to([titleImageEl.current],0.1,{
        top: '10.821875vw',
        width: '25.98958333vw',
        height: '5.7vw',
        opacity:1,
        ease: "power1.out",
        translateY: 0
      },'first')
      .to(listEl.current,0.1,{
        scale: 1.05,
      },'first')
      .to(mainEl.current,0.1,{
        paddingTop: '0vh',
      },'first')
      .to(listEl.current,0,{
        scale: 1,
      },'second')
      .to(mainEl.current,0,{
      },'second')
      .to([maxImageEl.current],0,{
        marginTop: '0vh',
        translateY: 0
      },'second')
      .to([titleImageEl.current],0,{
        marginTop: '0vh',
        translateY: 0
      },'second')
    }else{
    tl2.to(rootEl.current,0.5,{
      translateY: 0,
    },'first')
    .to([maxImageEl.current],0.1,{
      top: '3.25520835vw',
      width: '41.1458333vw',
      height: '20.8333333vw',
      opacity: '0.3',
      translateY: 0
    },'third')
    .to([titleImageEl.current],0.1,{
      top: '10.821875vw',
      width: '25.98958333vw',
      height: '5.7vw',
      opacity:1,
      ease: "power1.out",
      translateY: 0
    },'third')
    .to(listEl.current,0.1,{
      scale: 1.05,
    },'third')
    .to(mainEl.current,0.1,{
      paddingTop: '0vh',
    },'third')
    .to(listEl.current,0,{
      scale: 1,
    },'four')
    .to(mainEl.current,0,{
    },'four')
    .to([maxImageEl.current],0,{
      marginTop: '0vh',
      translateY: 0
    },'four')
    .to([titleImageEl.current],0,{
      marginTop: '0vh',
      translateY: 0
    },'four')
    }

    controller = new ScrollMagic.Controller();
    scene = new ScrollMagic.Scene({
      triggerElement: rootEl.current,
      triggerHook: 0,
      offset: isMobile? -window.innerHeight * 0.2 : -window.innerHeight * 0.8,
    })
    // .setPin(rootEl.current)
    .setTween(tl)
    .addTo(controller);
    scene.on("progress", function(event) {
      let ep = event.progress;
      if( ep >0 ){
        tl2.play()
      }
    })
  }
  //  ;
  const initMobile = () => {
    let height = 0
    if(list.length>10){
      height = window.innerWidth * 3.723701492546268* 0.89333333 + 60 + 40 + window.innerWidth * 0.426666665;
    }else if(list.length>9){
      height = window.innerWidth * 3.5223880597014925* 0.89333333 + 60 + 40 + window.innerWidth * 0.426666665;
    }else if(list.length>8){
      height = window.innerWidth * 3.1880597014925374* 0.89333333 + 48 + 40 + window.innerWidth * 0.426666665;
    }else if(list.length>7){
      height = window.innerWidth * 3.014925373134328* 0.89333333 + 48 + 40 + window.innerWidth * 0.426666665;
    }else if(list.length>6){
      height = window.innerWidth * 2.6686567164179102* 0.89333333 + 36 + 40 + window.innerWidth * 0.426666665;
    }else if(list.length>5){
      height = window.innerWidth * 2.2208955223880595* 0.89333333 + 24 + 40 + window.innerWidth * 0.426666665;
    }else if(list.length>2){
      height = window.innerWidth * 1.6597014925373135* 0.89333333 + 12 + 40 + window.innerWidth * 0.426666665;
    } else {
      height = window.innerWidth * 0.8597014925373134 * 0.89333333 + 40 + window.innerWidth * 0.426666665;
    }
    setPhotoWall({
      height: height,
      background: theme?.fields?.key?.value
    })
    ScrollMagic = loadScrollMagic()
    tl = gsap.timeline();
    tl
    .to([maxImageEl.current,titleImageEl.current],{
      scale: 1,
      opacity: 1
    },'first')
    .to(listEl.current,{
      marginTop: 40,
    },'first')
    controller = new ScrollMagic.Controller();
    scene = new ScrollMagic.Scene({
      triggerElement: rootEl.current,
      triggerHook: 'onEnter',
      duration: '100%',
    })
    .setTween(tl)
    .addTo(controller);
  }
  const onScroll = () => {
    if(rootEl.current ){
      let top = rootEl.current.getBoundingClientRect().top;
      if(top>0.8*window.innerHeight){

      }
      if(top > window.innerHeight && tl2!=null){

          tl2.pause(0)
      }
    }
  }
  return (
    <div className="PhotoWall" datasourceid={props.rendering.dataSource} style={photoWall}>
      <div className="PhotoWall-root" ref={rootEl}>
        <div className="PhotoWall-main" ref={mainEl} >
          <div className="PhotoWall-MaxImage" ref={maxImageEl}>
            <div className="PhotoWall-MaxImage-image">
              <Image className="img" { ...image.value} />
            </div>
          </div>
          
          <div className="PhotoWall-titleImage" ref={titleImageEl}>
            <div className="PhotoWall-titleImage-image">
              <Image className="img" { ... isMobile ? titleImageMobile.value : titleImage.value} />
            </div>
          </div>
          <div className="PhotoWall-list" ref={listEl} >
          {
            list.map( (item,index) => {
              return (
                <PhotoWallImage index={index} item={item}></PhotoWallImage>
              )
            }
            )
          }
          </div>
        </div>
      </div>
    </div>
  )
};
export default PhotoWall;
